import script from "./RateCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./RateCard.vue?vue&type=script&lang=ts&setup=true"

import "./RateCard.vue?vue&type=style&index=0&id=01284dff&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01284dff"]])

export default __exports__